/**
 * Vowella Gifts — split hero header behavior.
 *
 * While the hero-split section is in view at the top of the page, the
 * site header floats transparently on top of it (class
 * `vowella-header--overlay`, styled in vowella-custom.css). Once the
 * visitor scrolls past the hero, the class is removed and the header
 * falls back to its normal Dawn styling.
 *
 * Scoped entirely to pages that render a [data-vowella-transparent-header]
 * section — does nothing on any other page/template.
 */
(function () {
  function init() {
    var hero = document.querySelector('[data-vowella-transparent-header]');
    var header = document.querySelector('.section-header');
    if (!hero || !header) return;

    function update() {
      var rect = hero.getBoundingClientRect();
      var headerHeight = header.offsetHeight || 80;
      if (rect.bottom > headerHeight) {
        header.classList.add('vowella-header--overlay');
      } else {
        header.classList.remove('vowella-header--overlay');
      }
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
